import { CreateFileFolderData, FileFolder } from '@/helpers/hubspot/types';
import logError from '@/helpers/logError';
import { Dispatch } from 'react';
import { ReplaceInPersonFormState } from '../../../../../constants';
import { PictureStepActions } from '../../../state';
import { ReplaceInPersonFormActionMap } from '../../../../../reducer';

export const getHubspotFileFolder = async (
	state: ReplaceInPersonFormState,
	dispatch: Dispatch<ReplaceInPersonFormActionMap>,
) => {
	if (state.hubspotFolderId) {
		return state.hubspotFolderId;
	}
	const createFileFolderBody: CreateFileFolderData = {
		name: state.sessionId,
	};

	const fileFolder = (await fetch('/api/hubspot/file/folder', {
		method: 'POST',
		body: JSON.stringify(createFileFolderBody),
	})
		.then((response) => response.json())
		.catch((error) => {
			if (error instanceof Error) {
				logError(error);
			}
			return null;
		})) as FileFolder | null;

	if (!fileFolder || !fileFolder.id) {
		logError(new Error('Failed to create HubSpot file folder'));
		return null;
		// dispatch({ type: ActionTypes.SET_REJECTED, payload: null });
		// throw new Error('Failed to create file folder');
	}

	const hubspotFolderId = fileFolder.id;
	dispatch({
		type: PictureStepActions.SET_HUBSPOT_FOLDER_ID,
		payload: { hubspotFolderId },
	});

	return hubspotFolderId;
};
